import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { fetchSubscribedPlans } from '../Redux/SubscribedPlansSlice';

const SubscriptionPage = () => {
  const dispatch = useDispatch();
  const { id, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (id && token) {
      dispatch(fetchSubscribedPlans({ userId: id, token }));
    }
  }, [dispatch, id, token]);
  
  return (
    <div className='h-screen overflow-auto scrollbar-thin scrollbar-webkit relative'>
      <div className='flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-between sm:items-center'>
        <p className='text-xl text-center lg:text-2xl font-semibold'>Subscriptions</p>
      </div>
      <Outlet />
    </div>
  );
};

export default SubscriptionPage;
